import { render } from "./Advisors.vue?vue&type=template&id=9d2f3944&scoped=true"
import script from "./Advisors.vue?vue&type=script&lang=js"
export * from "./Advisors.vue?vue&type=script&lang=js"

import "./Advisors.vue?vue&type=style&index=0&id=9d2f3944&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d2f3944"]])

export default __exports__